import { ColorPicker } from '@supplement-bacon/react-toolkit/components'
import { SBRMFormActionProps } from '@supplement-bacon/sbrm-react'
import { Form } from 'antd'
import { requiredRule } from '../../../../utils/rules'
import AttachmentEditor from '../../../AttachmentEditor'
import { Localizable } from '../../../localizable/Localizable'

const Create = ({ form, formProps }: SBRMFormActionProps) => {
  return (
    <Form {...formProps} form={form} layout="vertical">
      <Localizable.Input
        name="label"
        rules={[requiredRule()]}
        label={'Label'}
        max={45}
      />
      <Localizable.Input name="description" label={'Description'} max={70} />

      <Form.Item name="color" label="Color">
        <ColorPicker />
      </Form.Item>
      <AttachmentEditor
        formItem={{ name: 'picture', rules: [requiredRule()] }}
        dragger={{ fileTypes: ['picture'] }}
        image={{ width: 512, height: 512, aspect: 1 }}
      />
    </Form>
  )
}

export default Create
